import Constants from 'js/Constants';
import {
  GET_FLOW_RUNS_FAILURE,
  GET_FLOW_RUNS_REQUEST,
  GET_FLOW_RUNS_SUCCESS,
} from 'js/constants/actionTypes';
import { CALL_PRIVATE_API } from 'js/constants/api';
import { GET } from 'js/constants/requestMethods';
import runsSchema from 'js/schemas/runs';
import { DispatchType } from 'src/@types/redux';

function loadFlowRuns(params: { page?: number }) {
  const { page = 1 } = params ?? {};

  return (dispatch: DispatchType, getState: any) => {
    const state = getState();
    const aclQueryMode = state.app.listing.aclQueryMode;

    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [GET_FLOW_RUNS_REQUEST, GET_FLOW_RUNS_SUCCESS, GET_FLOW_RUNS_FAILURE],
        requestMethod: GET,
        endpoint: '/flows',
        payload: {
          include_run_metrics: 1, // don't remove this, it's used by the backend to return the run metrics
          page,
          per_page: Constants.LISTING_ITEMS_PER_PAGE,
        },
        requestInfo: {},
        schema: runsSchema,
        aclQueryMode,
      },
    });
  };
}

export { loadFlowRuns };
